import script from "./CatalogPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./CatalogPage.vue?vue&type=script&setup=true&lang=ts"

import "./CatalogPage.vue?vue&type=style&index=0&id=b10a6af0&lang=scss"

const __exports__ = script;

export default __exports__